import { PageText } from "../../../../../components/Text/Text";
import { GridSystem } from "../../../../Components/GridSystem/GridSystem"
import styles from "./DetailsSection.module.css";
export const DetailSection = ({
    title,
    children,
    containerBackgroundColor,
    borderTopColor = "var(--color-gray-04)",
     borderBottomColor = "var(--color-gray-04)"
}) => {
    return (
        <GridSystem

            containerBackgroundColor={containerBackgroundColor || 'var(--color-gray-07)'}
            containerBorderTop={`1px solid ${borderTopColor}`}
             containerBorderBottom={`1px solid ${borderBottomColor}`}
            containerPaddingTop="4rem"
            containerPaddingBottom="4rem"
        >
            <div className={styles.detailSectionContainer}>

                {title &&
                    <div className={styles.titleWrapper}>
                        <PageText type="bodyTitle">{title}</PageText>
                    </div>
                }

                <div className={styles.childrenWrapper}>
                    {children}
                </div>
            </div>

        </GridSystem>

    );
};